module.exports = __WEBPACK_EXTERNAL_MODULE_68__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs":"vue","commonjs2":"vue","amd":"vue"}
// module id = 68
// module chunks = 0